<div [style.display]="appService.isShowPageSpinner ? 'block' : 'none'" class="loadingContainer">
  <div class="overlay">
    <p-progressSpinner strokeWidth="7" class="spinner"></p-progressSpinner>
  </div>
</div>